import React, { useState, useEffect } from 'react';
import { Modal, Menu, Spin, Tooltip, notification } from 'antd';
import axios from "axios";
import Config from './../../../../config'
import './DocModal.css'

const DocModal = ({ type, DocList }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDocPrev, setIsDocPrev] = useState(false);
  const [DocListByType, setDocListByType] = useState([]);
  const [menuKey, setMenuKey] = useState(1);
  const [selectedItem, setSelectedItem] = useState(0);
  const [DocUrl, setDocUrl] = useState(1);
  const [loader, setLoader] = useState(true);

  const showModal = () => {
    setIsModalVisible(true);
    if (DocListByType.length > 0) {
      clickMenu(0)
    }
  };

  const handleOk = () => {
    return
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDocByType = () => {
    let DocType = type == 'EOB' ? "ClaimLevelEOB" : "EOPRemittance"
    let ByType = DocList.filter(item => (
      item.letterType == DocType
    ))
    setDocListByType(ByType)
  }

  const clickMenu = (idx) => {
    setIsDocPrev(true)
    setSelectedItem(idx)
    let ClickedItem = DocListByType[idx]
    setLoader(true);
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/pdf",
        // "Content-Disposition": "attachment",
      },
      responseType: "arraybuffer",
    };
    axios
      .get(
        `${Config.api}/GetClaimDeatilsDocument?LetterKey=${ClickedItem.letterKey}&DocumentName=${ClickedItem.letterName}&DocumentType=${ClickedItem.letterType}&PlanName=${sessionStorage.getItem("planName")}`,
        axiosConfig
      )
      .then((res) => {
        let blob = new Blob([res.data], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(blob);
        setDocUrl(fileURL);
        setLoader(false);
      })
      .catch((err) => {
        notification.open({
          message: 'Failed loading document',
        });
      });
  };

  useEffect(() => {
    handleDocByType()
  }, [])

  return (
    <>
      <div className="claims-details-text ellipsisText blueAnchor">
        <a onClick={showModal} style={{color: '#427bddeb'}}>
          View Documents
        </a>
      </div>
      <Modal
        footer={null}
        title={<div className="documentPreview">Document Preview</div>}
        visible={isModalVisible}
        width={920}
        style={{ marginTop: "-65px" }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="availableDoc" style={{ padding: '5px' }}>Available Documents: {DocListByType.length}</div>
        <div className='PreviewContainer'>
          <div className='DocList bgOfSideMenu'>
            <Menu
              defaultSelectedKeys={["0"]}
              className="docMenuHeight"
              key={menuKey}
            >
              {DocListByType.map((item, idx) => {
                return (
                  <Menu.Item
                    key={idx}
                    onClick={() => clickMenu(idx, item.DocumentID)}
                    className="docItem"
                  >
                    <Tooltip placement="right" title={item.letterName}>
                      <div className="docItemText">
                        <span>
                          {item.letterName}
                        </span>
                      </div>
                    </Tooltip>
                  </Menu.Item>
                );
              })}
            </Menu>
          </div>
          {isDocPrev &&
            <div className='DocPrev'>
              {DocUrl && !loader ? (
                <iframe
                  src={DocUrl}
                  height="100%"
                  width="100%"
                  style={{ border: "0" }}
                />
              ) : (
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Spin size="large" />
                </div>
              )}
            </div>
          }
        </div>
      </Modal>
    </>
  );
};


export default DocModal